import { render } from "./TeamView.vue?vue&type=template&id=15f9b2d0&ts=true"
import script from "./TeamView.vue?vue&type=script&lang=ts"
export * from "./TeamView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__